import { Injectable } from '@angular/core';
import { HttpService } from '../providers/http.service';
import { AppConfig } from '../app/app.config';



@Injectable()
export class OpenAccountService {
    constructor(
        private httpService: HttpService) { }

    //手动开户
    //chen 2017-01-05
    postAddUser(obj) {
        let params = {
            "UserName": obj.UserName,
            "Bonus": obj.Bonus,
            "UserType": obj.UserType,
            "UserPassword": obj.UserPassword,
            "DailyWages":obj.DailyWages
        };
        let url = AppConfig.GetProdUrl() + "/Team/AddUser";
        return this.httpService.post(url, params);
    }

    //生成链接
    //chen 2017-01-05
    getLink(bouns: Number, userType: string) {
        let url = AppConfig.GetProdUrl() + "/Team/AddRegisterLink";
        let params = "bouns=" + bouns + "&userType=" + userType;
        return this.httpService.get(url + "?" + params);
    }

    //链接开户
    //chen 2017-01-06
    linkOpenAccount(Link: string, registerUserName: string, registerPassWord: string, registerEmail: string, code: string, registerQQ: string) {
        let url = AppConfig.GetProdUrl() + "/Team/AddRegisterLink";
        let params = "Link=" + Link + "&registerUserName=" + registerUserName + "&registerPassWord=" + registerPassWord + "&registerEmail=" + registerEmail + "&code=" + code + "&registerQQ=" + registerQQ;
        return this.httpService.get(url + "?" + params);
    }

    // 生成链接
    addRegisterLinkNew(params) {
        let url = AppConfig.GetProdUrl() + "/Team/AddRegisterLink";
        return this.httpService.post(url, params);
    }

    //获取用户类别
    //TQQ 2017-02-24
    getUserType() {
        let url = AppConfig.GetProdUrl() + "/User/QueryUserType";
        return this.httpService.get(url);
    }

    //获取开户连接的列表
    //TQQ 2017-02-24
    getRegisterLinkList() {
        let url = AppConfig.GetProdUrl() + "/Team/QueryRegisterLinkList";
        return this.httpService.get(url);
    }

    //删除注册链接
    //TQQ 2017-02-24
    removeLink(id) {
        let url = AppConfig.GetProdUrl() + "/Team/DelRegisterLink?id=" + id;
        return this.httpService.get(url);
    }

    //检测用户名是否存在
    //TQQ 2018-08-29
    checkUserName(params) {
        let url = AppConfig.GetProdUrl() + "/User/CheckUserName";
        return this.httpService.get(url, params);
    }

    //注册用户
    //TQQ 2018-08-29
    registerUser(params) {
        let url = AppConfig.GetProdUrl() + "/User/RegisterUserByKey";
        return this.httpService.get(url, params);
    }



}





// WEBPACK FOOTER //
// ./src/services/openAccount.service.ts